import { AssetActionTypes } from './asset.types'

//Add Asset
export const addAssetRequest = data => ({
    type: AssetActionTypes.ADD_ASSET_REQUEST,
    payload: data
})

export const addAssetRequestSuccess = data => ({
    type: AssetActionTypes.ADD_ASSET_REQUEST_SUCCESS,
    payload: data
})

export const addAssetRequestError = data => ({
    type: AssetActionTypes.ADD_ASSET_REQUEST_ERROR,
    payload: data
})

export const addAssetRequestStatus = data => ({
    type: AssetActionTypes.ADD_ASSET_REQUEST_STATUS,
    payload: data
})

//Asset List
export const assetListRequest = data => ({
    type: AssetActionTypes.ASSET_LIST_REQUEST,
    payload: data
})

export const assetListRequestSuccess = data => ({
    type: AssetActionTypes.ASSET_LIST_REQUEST_SUCCESS,
    payload: data
})

export const assetListRequestError = data => ({
    type: AssetActionTypes.ASSET_LIST_REQUEST_ERROR,
    payload: data
})

//Asset Detail
export const assetDetailRequest = data => ({
    type: AssetActionTypes.ASSET_DETAIL_REQUEST,
    payload: data
})

export const assetDetailRequestSuccess = data => ({
    type: AssetActionTypes.ASSET_DETAIL_REQUEST_SUCCESS,
    payload: data
})

export const assetDetailRequestError = data => ({
    type: AssetActionTypes.ASSET_DETAIL_REQUEST_ERROR,
    payload: data
})

//Assign Asset
export const assignAssetRequest = data => ({
    type: AssetActionTypes.ASSIGN_ASSET_REQUEST,
    payload: data
})

export const assignAssetRequestSuccess = data => ({
    type: AssetActionTypes.ASSIGN_ASSET_REQUEST_SUCCESS,
    payload: data
})

export const assignAssetRequestError = data => ({
    type: AssetActionTypes.ASSIGN_ASSET_REQUEST_ERROR,
    payload: data
})

export const assignAssetRequestStatus = data => ({
    type: AssetActionTypes.ASSIGN_ASSET_REQUEST_STATUS,
    payload: data
})

//Un Assign Asset
export const unAssignAssetRequest = data => ({
    type: AssetActionTypes.UN_ASSIGN_ASSET_REQUEST,
    payload: data
})

export const unAssignAssetRequestSuccess = data => ({
    type: AssetActionTypes.UN_ASSIGN_ASSET_REQUEST_SUCCESS,
    payload: data
})

export const unAssignAssetRequestError = data => ({
    type: AssetActionTypes.UN_ASSIGN_ASSET_REQUEST_ERROR,
    payload: data
})

export const unAssignAssetRequestStatus = data => ({
    type: AssetActionTypes.UN_ASSIGN_ASSET_REQUEST_STATUS,
    payload: data
})

//Update Asset Status
export const updateAssetStatusRequest = data => ({
    type: AssetActionTypes.UPDATE_ASSET_STATUS_REQUEST,
    payload: data
})

export const updateAssetStatusRequestSuccess = data => ({
    type: AssetActionTypes.UPDATE_ASSET_STATUS_REQUEST_SUCCESS,
    payload: data
})

export const updateAssetStatusRequestError = data => ({
    type: AssetActionTypes.UPDATE_ASSET_STATUS_REQUEST_ERROR,
    payload: data
})

export const updateAssetStatusRequestStatus = data => ({
    type: AssetActionTypes.UPDATE_ASSET_STATUS_REQUEST_STATUS,
    payload: data
})